import { Trans } from '@lingui/macro'
import * as React from 'react'
import styled from 'styled-components'

import { GridBox } from '../atoms/Box/Box'
import { Icon } from '../atoms/Icon'
import { getSpaceValue } from '../designSystem'
import { i18n } from '../i18n'
import { PageTitle } from '../molecules/HeaderLayout/PageTitle'
import { SmallTouchButton } from '../molecules/TouchButton'
import { ROUTE_SUPPORT } from '../screens/dashboard/dashboard.routes'
import { Colors } from '../styling'
import { AppNameScreen } from '../ui/AppNameScreen'
import { IconAppError } from '../ui/Icons'

type TProps = NoChildren & {
  onRetry(): void
}

const StyledMessage = styled(AppNameScreen.Message)`
  a {
    color: inherit;
    text-decoration: underline;
    text-decoration-color: rgba(255, 255, 255, 0.3);

    &:hover {
      text-decoration-color: rgba(255, 255, 255, 0.8);
    }

    &:visited {
      text-decoration-color: rgba(255, 255, 255, 0.3);
    }
  }
`

const StyledButton = styled(SmallTouchButton)`
  padding: 0 ${getSpaceValue(`s24`)};
  margin: 0 auto;
`

export const ServiceUnreachablePage: React.FC<TProps> = ({ onRetry }) => (
  <AppNameScreen.Layout>
    <PageTitle title={i18n.t`Service unreachable`} />
    <AppNameScreen.Headline textAlign={`center`} />

    <GridBox gridGap={getSpaceValue(`s32`)}>
      <StyledMessage textAlign={`center`}>
        <Trans>
          Connection to external service is not possible at the moment. Please
          try again later or <a href={ROUTE_SUPPORT}>contact our support</a>.
        </Trans>
      </StyledMessage>

      <Icon icon={IconAppError} fontSize={7} color={Colors.red.dark} />

      <StyledButton
        onClick={onRetry}
        width={`fit-content`}
        color={Colors.speedlo.main}
      >
        <Trans>Retry the connection</Trans>
      </StyledButton>
    </GridBox>
  </AppNameScreen.Layout>
)
